const state = {
  counter: 1234567890,
}

const mutations = {}

const actions = {}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: {},
}
